import { ApiBeneficiary } from '../openapi';

export function isBeneficiaryMatch(query: string, beneficiary: ApiBeneficiary) {
  // Search by beneficiary ID
  if (beneficiary.beneficiaryId === query) return true;

  // Search by display name
  if (beneficiary.displayName?.toLowerCase().includes(query)) return true;

  // Search by type
  if (beneficiary.type?.toLowerCase().includes(query)) return true;

  // Search by currency
  if (beneficiary.currency?.toLowerCase().includes(query)) return true;

  // Search by account number
  if (beneficiary.accountNumber?.value?.toLowerCase().includes(query)) return true;

  // Type-specific searches
  if (beneficiary.type === 'INDIVIDUAL') {
    if (beneficiary.individualName?.toLowerCase().includes(query)) return true;
  }

  if (beneficiary.type === 'BUSINESS') {
    if (beneficiary.businessName?.toLowerCase().includes(query)) return true;
  }

  if (beneficiary.type === 'CRYPTO') {
    if (beneficiary.beneficiaryName?.toLowerCase().includes(query)) return true;
    if (beneficiary.accountNumber?.type?.toLowerCase().includes(query)) return true;
    if (beneficiary.subtype?.toLowerCase().includes(query)) return true;
  }

  return false;
}
